module.exports = new __parcel__URL__("arrow-left-match.5ea6990b.svg").toString();